export default __webpack_public_path__ + "static/media/test-tube.06e661ce.svg";